import axios from "axios";
import { GlobalResType } from "DataTypes/Common";
import { setAlertData } from "../Redux/Screen/Action";
import { store } from "../Redux/Store";
import { Admin_Number, CheckStringEmpty } from "Utils/Common";
import { clearUser } from "../Redux/User/Action";
import { disconnectChatHub } from "./signalRService";

let isRefreshing = false;
let failedQueue: Array<{ resolve: (token: string) => void; reject: (err: any) => void }> = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token!);
    }
  });
  failedQueue = [];
};

export const get = (request: any) => {
  return commonFetch({ method: "get", ...request });
};

export const post = (request: any) => {
  return commonFetch({ method: "post", ...request });
};

export const patch = (request: any) => {
  return commonFetch({ method: "patch", ...request });
};

export const put = (request: any) => {
  return commonFetch({ method: "put", ...request });
};

export const deletee = (request: any) => {
  return commonFetch({ method: "delete", ...request });
};

export const abortSignal = axios.CancelToken.source();

// const commonFetch: (request: any) => any = (request: any) => {
//   const dispatch = store.dispatch;
//   try {
//     const {
//       subUrl,
//       method,
//       data = {},
//       params = {},
//       headers = {},
//       isAuth,
//       isPayment,
//       isChat,
//       excel,
//       dataType = "json",
//     } = request;

//     let url;
//     const baseUrlAuth = process.env.REACT_APP_BASE_URL;
//     if (isAuth) url = `${baseUrlAuth}/api/Auth/${subUrl}`;
//     else if (isPayment) url = `${baseUrlAuth}/api/Payments/${subUrl}`;
//     else if (isChat) url = `${baseUrlAuth}/api/Chat/${subUrl}`;
//     else url = `${baseUrlAuth}/api/${subUrl}`;

//     const passedHeaders = headers;
//     const commonHeaders = getCommonHeaders(excel, dataType);
//     const responseType = excel ? "blob" : "json";
//     return axios({
//       method,
//       url,
//       responseType,
//       data,
//       withCredentials: false,
//       headers: excel
//         ? { ...commonHeaders }
//         : { ...commonHeaders, ...passedHeaders },
//       params,
//     })
//       .then((response) => {
//         return {
//           success: true,
//           data: response?.data,
//           alert: {
//             alertMessage: response?.data?.message || "",
//             openAlert: response?.data?.message ? true : false,
//             alertVariant: "success",
//           },
//         };
//       })
//       .catch((error) => {
//         console.log("error --------> ", error);
//         if (error?.response?.status === 400) {
//           console.log("error?.response?.data?.title", error?.response?.data?.title);
//           //   Dispatch Error Unable to perform this action. Please try after sometime.
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else if (error?.response?.status === 401) {
//           // Handle Session (Error  Session has expired. Please log in again.)
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else if (error?.response?.status === 403) {
//           //   handle Authorization Error (You are not authorized to perform this action.)
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else if (error?.response?.status === 404) {
//           //   Handle Resource Not Found Error (Resource not found. Please try after sometime.)
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else if (error?.response?.status === 500) {
//           // Handle Something went wrong. Please login after sometime
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else {
//           // Handle Something went wrong. Please login after sometime
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         }
//       });
//   } catch (err) {
//     // Handle Error Here
//     return {
//       success: true,
//       data: null,
//       alert: {
//         alertMessage: "",
//         openAlert: false,
//         alertVariant: "error",
//       },
//     };
//   }
// };

const commonFetch: (request: any) => any = (request: any) => {
  const dispatch = store.dispatch;
  try {
    const {
      subUrl,
      method,
      data = {},
      params = {},
      headers = {},
      isAuth,
      isPayment,
      isChat,
      isTwilio,
      excel,
      dataType = "json",
    } = request;

    const baseUrlAuth = process.env.REACT_APP_BASE_URL;

    const url = isAuth
      ? `${baseUrlAuth}/api/Auth/${subUrl}`
      : isPayment
        ? `${baseUrlAuth}/api/Payments/${subUrl}`
        : isChat
          ? `${baseUrlAuth}/api/Chat/${subUrl}`
          : isTwilio
            ? `${baseUrlAuth}/api/ConferenceCall/${subUrl}`
            : `${baseUrlAuth}/api/${subUrl}`;

    const commonHeaders = getCommonHeaders(excel, dataType);
    const responseType = excel ? "blob" : "json";

    return axios({
      method,
      url,
      responseType,
      data,
      withCredentials: true,
      headers: excel ? { ...commonHeaders } : { ...commonHeaders, ...headers },
      params,
      paramsSerializer: {
        serialize: (params) => {
          const searchParams = new URLSearchParams();
          for (const key of Object.keys(params)) {
            const value = params[key];
            if (value === null || value === undefined) continue;
            
            if (Array.isArray(value)) {
              for (const item of value) {
                searchParams.append(key, item);
              }
            } else {
              searchParams.append(key, value);
            }
          }
          return searchParams.toString();
        }
      }
    })
      .then((response) => {
        const serverData = response?.data;
        
        // Check if server already sent a structured ApiResponseDto
        if (serverData && typeof serverData.success === "boolean") {
            // Automatically show alert if requested by server
            if (serverData.alert?.openAlert && serverData.alert?.alertMessage) {
                dispatch(setAlertData({
                    alertMessage: serverData.alert.alertMessage,
                    alertVariant: serverData.alert.alertVariant || "success",
                    openAlert: true
                }));
            }
            return serverData;
        }

        return {
          success: true,
          data: serverData,
          alert: {
            alertMessage: serverData?.message || "",
            openAlert: !!serverData?.message,
            alertVariant: "success",
          },
        };
      })
      .catch(async (error) => {
        const status = error?.response?.status;
        const serverError = error?.response?.data;

        const title =
          CheckStringEmpty(serverError?.alert?.alertMessage) ||
          CheckStringEmpty(serverError?.message) ||
          CheckStringEmpty(serverError?.Message) ||
          CheckStringEmpty(serverError?.title) ||
          CheckStringEmpty(typeof serverError === "string" ? serverError : "") ||
          CheckStringEmpty(error?.message) ||
          `Something went wrong. Please contact administrator. ${Admin_Number}`;

        if (status !== 401) {
            dispatch(
              setAlertData({
                alertMessage: title,
                openAlert: true,
                alertVariant: "error",
              })
            );
        }

        if (status === 401) {
          const refreshToken = localStorage.getItem("refreshToken")?.replace(/(^"|"$)/g, '');
          const localToken = localStorage.getItem("token");
          const accessToken = localToken ? localToken.replace(/(^"|"$)/g, '') : "";

          // Allow refresh if accessToken exists. refreshToken can be null on Web (managed via HttpOnly cookie)
          if (accessToken && !error.config._retry) {
            error.config._retry = true;

            if (isRefreshing) {
              try {
                const token = await new Promise<string>((resolve, reject) => {
                  failedQueue.push({ resolve, reject });
                });
                const originalRequest = error.config;
                originalRequest.headers['Authorization'] = `Bearer ${token}`;
                const retryRes = await axios(originalRequest);
                return {
                  success: true,
                  data: retryRes.data,
                  alert: {
                    alertMessage: retryRes.data?.message || "",
                    openAlert: !!retryRes.data?.message,
                    alertVariant: "success",
                  },
                };
              } catch (err) {
                // FALL THROUGH
              }
            } else {
              isRefreshing = true;
              try {
                const refreshUrl = `${baseUrlAuth}/api/Auth/refresh`;
                const refreshRes = await axios.post(refreshUrl, {
                  accessToken: accessToken,
                  refreshToken: refreshToken || null
                }, { withCredentials: true });

                if (refreshRes.data && refreshRes.data.token) {
                  localStorage.setItem('token', refreshRes.data.token);
                  if (refreshRes.data.refreshToken) {
                    localStorage.setItem('refreshToken', refreshRes.data.refreshToken);
                  } else {
                    localStorage.removeItem('refreshToken');
                  }

                  processQueue(null, refreshRes.data.token);

                  const originalRequest = error.config;
                  originalRequest.headers['Authorization'] = `Bearer ${refreshRes.data.token}`;

                  const retryRes = await axios(originalRequest);
                  return {
                    success: true,
                    data: retryRes.data,
                    alert: {
                      alertMessage: retryRes.data?.message || "",
                      openAlert: !!retryRes.data?.message,
                      alertVariant: "success",
                    },
                  };
                } else {
                  processQueue(new Error("Refresh failed"));
                }
              } catch (refreshErr) {
                console.error("Refresh token failed", refreshErr);
                processQueue(refreshErr);
              } finally {
                isRefreshing = false;
              }
            }
          }

          dispatch(
            setAlertData({
              alertMessage: title || "Session expired. Please log in again.",
              openAlert: true,
              alertVariant: "error",
            })
          );

          await disconnectChatHub().catch(() => { });

          // 1. Clear credentials
          localStorage.clear();
          dispatch(clearUser() as any);

          // 2. Use a smooth SPA navigation instead of window.location
          // This prevents the "White Flash" of a full reload
          import("../Utils/Common").then(({ safeNavigate }) => {
            // We pass the message in the state or query so Login can show it
            safeNavigate("/login");
          });
        }

        return {
          success: false,
          data: null,
          alert: {
            alertMessage: title,
            openAlert: true,
            alertVariant: "error",
          },
        };
      });
  } catch (err) {
    return {
      success: false,
      data: null,
      alert: {
        alertMessage: "Unexpected error occurred.",
        openAlert: true,
        alertVariant: "error",
      },
    };
  }
};

const getCommonHeaders = (excel: any, dataType: "json" | "form-data") => {
  const localToken = localStorage.getItem("token") || "";
  const userId = localStorage.getItem("x-nlp-userid") || "";
  const tokenStorage = localToken ? localToken.replace(/(^"|"$)/g, '') : "";

  const headerObj = {
    "Accept": "*/*",
    "Content-Type":
      dataType === "form-data" ? "multipart/form-data" : "application/json",
    "Authorization": tokenStorage ? `Bearer ${tokenStorage}` : "",
    "x-nlp-userid": userId,
    "Access-Control-Allow-Origin": "*",
  };
  const headerObjForExcel = {
    "Authorization": tokenStorage ? `Bearer ${tokenStorage}` : "",
    "x-nlp-userid": userId,
  };
  return excel ? headerObjForExcel : headerObj;
};

export const upload = (request: any) => {
  const dispatch = store.dispatch;

  try {
    const {
      subUrl,
      method = "post",
      data,
      params = {},
      headers = {},
      isAuth,
      isPayment,
      forceContentType = false,
    } = request;

    let url = "";
    const baseUrlAuth = process.env.REACT_APP_BASE_URL;

    if (isAuth) url = `${baseUrlAuth}/api/Auth/${subUrl}`;
    else if (isPayment) url = `${baseUrlAuth}/api/Payments/${subUrl}`;
    else url = `${baseUrlAuth}/api/${subUrl}`;

    const token = localStorage.getItem("cm-token");
    const tokenStorage = token ? JSON.parse(token) : "";

    // 🎯 Direct extraction from localStorage
    const localToken = localStorage.getItem("token") || "";
    const userId = localStorage.getItem("x-nlp-userid") || "";

    // ⚠️ Build headers without forcing Content-Type
    const authHeaders = {
      "Authorization": localToken ? `Bearer ${localToken}` : "",
      "x-nlp-userid": userId,
      // Authorization: tokenStorage ? `Bearer ${tokenStorage}` : "",
      ...headers,
    };

    if (forceContentType) {
      authHeaders["Content-Type"] = "multipart/form-data";
    }

    return axios({
      method,
      url,
      data,
      params,
      headers: authHeaders,
      // DO NOT set `withCredentials: false` — axios default is fine
    })
      .then((response) => {
        return {
          success: true,
          data: response?.data,
          alert: {
            alertMessage: response?.data?.message || "",
            openAlert: !!response?.data?.message,
            alertVariant: "success",
          },
        };
      })
      .catch(async (error) => {
        if (error?.response?.status === 401) {
          const refreshToken = localStorage.getItem("refreshToken")?.replace(/(^"|"$)/g, '');
          const localToken = localStorage.getItem("token");
          const accessToken = localToken ? localToken.replace(/(^"|"$)/g, '') : "";

          if (refreshToken && accessToken && !error.config._retry) {
            error.config._retry = true;

            if (isRefreshing) {
              try {
                const token = await new Promise<string>((resolve, reject) => {
                  failedQueue.push({ resolve, reject });
                });
                const originalRequest = error.config;
                originalRequest.headers['Authorization'] = `Bearer ${token}`;
                const retryRes = await axios(originalRequest);
                return {
                  success: true,
                  data: retryRes.data,
                  alert: {
                    alertMessage: retryRes.data?.message || "",
                    openAlert: !!retryRes.data?.message,
                    alertVariant: "success",
                  },
                };
              } catch (err) {
                // FALL THROUGH
              }
            } else {
              isRefreshing = true;
              try {
                const refreshUrl = `${baseUrlAuth}/api/Auth/refresh`;
                const refreshRes = await axios.post(refreshUrl, {
                  accessToken: accessToken,
                  refreshToken: refreshToken
                });

                if (refreshRes.data && refreshRes.data.token && refreshRes.data.refreshToken) {
                  localStorage.setItem('token', refreshRes.data.token);
                  localStorage.setItem('refreshToken', refreshRes.data.refreshToken);

                  processQueue(null, refreshRes.data.token);

                  const originalRequest = error.config;
                  originalRequest.headers['Authorization'] = `Bearer ${refreshRes.data.token}`;

                  const retryRes = await axios(originalRequest);
                  return {
                    success: true,
                    data: retryRes.data,
                    alert: {
                      alertMessage: retryRes.data?.message || "",
                      openAlert: !!retryRes.data?.message,
                      alertVariant: "success",
                    },
                  };
                } else {
                  processQueue(new Error("Refresh failed"));
                }
              } catch (refreshErr) {
                console.error("Refresh token failed", refreshErr);
                processQueue(refreshErr);
              } finally {
                isRefreshing = false;
              }
            }
          }

          dispatch(
            setAlertData({
              alertMessage: error?.response?.data?.title || "Session expired. Please log in again.",
              openAlert: true,
              alertVariant: "error",
            })
          );

          localStorage.clear();
          dispatch(clearUser() as any);
          import("../Utils/Common").then(({ safeNavigate }) => {
            safeNavigate("/login");
          });
        } else {
          const title =
            CheckStringEmpty(error?.response?.data?.title) ||
            CheckStringEmpty(error?.response?.data?.message) ||
            CheckStringEmpty(error?.response?.data?.Message) ||
            CheckStringEmpty(error?.response?.data) ||
            "Upload failed.";
            
          dispatch(
            setAlertData({
              alertMessage: title,
              openAlert: true,
              alertVariant: "error",
            })
          );
        }
        return {
          success: false,
          data: null,
          alert: {
            alertMessage: CheckStringEmpty(error?.response?.data?.title) ||
                         CheckStringEmpty(error?.response?.data?.message) ||
                         CheckStringEmpty(error?.response?.data?.Message) ||
                         CheckStringEmpty(error?.response?.data) || "Upload failed.",
            openAlert: true,
            alertVariant: "error",
          },
        };
      });
  } catch (err) {
    return {
      success: false,
      data: null,
      alert: {
        alertMessage: "",
        openAlert: false,
        alertVariant: "error",
      },
    };
  }
};
